<template>
    <div class="four_content">
        <div class="sub_fou_content">
            <div class="sub_fou_left">
                <div class="sub_fou_ft">
                    <div></div>
                    <p>企业VIP</p>
                </div>
                <div class="sub_fou_st">一站式版权综合服务</div>
                <img style="width:557px;height:296px;margin-left:-133px" src="./../../images/first15.png" alt='版权登记'/>
            </div>
            <div class="sub_fou_right">
                <div class="subott">
                    <img style="width:86px;heihgt:43px;" src="./../../images/first16.png" alt='版权登记'/>
                    <div class="yesuboot">
                        <p>服务全面</p>
                        <div></div>
                    </div>
                    <p>为企业提供版权存证、版权登记、盗版监测、侵权取证、法律维权等传统的版权保护服务</p>
                </div>
                <div class="subott">
                    <img style="width:102px;heihgt:43px;" src="./../../images/first17.png" alt='版权登记'/>
                    <div class="yesuboot">
                        <p>经验丰富</p>
                        <div></div>
                    </div>
                    <p>整合、打造了内容创作、发布传播、授权开发、使用消费等完整的产业服务链条</p>
                </div>
                <div class="subott">
                    <img style="width:104px;heihgt:43px;" src="./../../images/first18.png" alt='版权登记'/>
                    <div class="yesuboot">
                        <p>生态完整</p>
                        <div></div>
                    </div>
                    <p style="margin-right:0px">覆盖艺术品、新媒体、影视、文学、游戏、图片、设计等行业板块</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'firfour',
        data(){
            return {

            }            
        },
        methods:{

        }
    }
</script>

<style scoped lang="less">
    .four_content{
        height:636px;
        background:rgba(255,255,255,1);
        .sub_fou_content{
            width:1334px;
            margin:0 auto;
            display:flex;
            justify-content: flex-start;
            .sub_fou_left{
                margin-top:90px;
                margin-right:24px;
                .sub_fou_ft{
                    height:55px;
                    line-height:55px;
                    display:flex;
                    justify-content: flex-start;
                    margin-bottom:13px;
                    p{
                        height:42px;
                        font-size:30px;
                        font-weight:800;
                        color:rgba(4,4,4,1);
                        letter-spacing:3px;
                        margin-left: -52px;
                    }
                    div{
                        width:55px;
                        height:55px;
                        background:rgba(255,216,0,1);
                        border-radius:50%;
                    }
                }
                .sub_fou_st{
                    height:28px;
                    font-size:20px;
                    font-weight:400;
                    color:rgba(4,4,4,1);
                    line-height:28px;
                    letter-spacing:2px;
                    margin-bottom:82px;
                }
            }
            .sub_fou_right{
                margin-top:216px;
                display:flex;
                justify-content: flex-start;
                .subott{
                    display:flex;
                    flex-direction:column;
                    p{
                        width:236px;
                        font-size:14px;
                        font-weight:400;
                        color:rgba(78,78,78,1);
                        line-height:24px;
                        letter-spacing:1px;
                        margin-right:57px;
                    }
                    .yesuboot{
                        margin-bottom:26px;
                        p{
                            height:28px;
                            font-size:20px;
                            font-weight:bold;
                            color:rgba(78,78,78,1);
                            line-height:28px;
                            letter-spacing:2px;
                        }
                        div{
                            height:14px;
                            background:rgba(252,213,1,1);
                            width:90px;
                            margin-top: -14px;
                        }
                    }
                }
            }
        }
    }
</style>